import { createUserManager } from 'redux-oidc';


const settings = {
  client_id: 'CDB_Client',
  response_type: 'id_token token',
  scope:"openid profile cdb_api cf_cdb_claims it_admin",
  automaticSilentRenew: false,
  loadUserInfo: true,
  monitorSession: false
};

switch (window.location.hostname) {
    case 'localhost':
        settings.authority = window['runConfig'].authorityUrlLocal;
        settings.redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].callbackLocal}`;
        settings.silent_redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].silentRenewLocal}`;
        settings.post_logout_redirect_uri = window['runConfig'].logoutRedirectUrlLocal;
        break;
    case 'bhcwebdev':
        settings.authority = window['runConfig'].authorityUrlDev;
        settings.redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].callbackDev}`;
        settings.silent_redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].silentRenewDev}`;
        settings.post_logout_redirect_uri = window['runConfig'].logoutRedirectUrlDev;
        break;
    case 'bhcwebdev.bhciss.com':
        settings.authority = window['runConfig'].authorityUrlDev;
        settings.redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].callbackDev}`;
        settings.silent_redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].silentRenewDev}`;
        settings.post_logout_redirect_uri = window['runConfig'].logoutRedirectUrlDev;
        break;
    case 'www.commercialfire.com':
        settings.authority = window['runConfig'].authorityUrlProd;
        settings.redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].callbackProd}`;
        settings.silent_redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].silentRenewProd}`;
        settings.post_logout_redirect_uri = window['runConfig'].logoutRedirectUrlProd;
        break;
    default:
        settings.authority = window['runConfig'].authorityUrlProd;
        settings.redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].callbackProd}`;
        settings.silent_redirect_uri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${window['runConfig'].silentRenewProd}`;
        settings.post_logout_redirect_uri = window['runConfig'].logoutRedirectUrlProd;
        break;
}


const userManager = createUserManager(settings);

export default userManager;